import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66433a7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vat-tu-reserve-alert d-flex align-items-center rounded px-3 py-2 bg-warning bg-opacity-10 border border-warning text-warning fs-6 fw-medium mb-3",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge bg-warning text-dark me-2" }, "Cần cập nhật", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Mức dự trữ tối thiểu hoặc tối đa đang bằng 0. Vui lòng cập nhật giá trị phù hợp. ")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "mb-3 d-flex align-items-center rounded px-3 py-2 bg-success bg-opacity-10 border border-success border-opacity-50 text-success fs-6 fw-medium",
  role: "status"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "✓"),
  /*#__PURE__*/_createTextVNode(" Dữ liệu vật tư đã được kiểm duyệt và sử dụng trong hệ thống quản lý ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "mb-3 d-flex align-items-center rounded px-3 py-2 bg-warning bg-opacity-10 border border-warning border-opacity-50 text-warning fs-6 fw-medium",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Vật tư mới cần được phê duyệt để sử dụng làm dữ liệu cho toàn hệ thống ")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_12 = { class: "col-12 col-md-6" }
const _hoisted_13 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "ID:", -1))
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Mã vật tư:", -1))
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Mức dự trữ tối thiểu:", -1))
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "mb-3 d-flex align-items-start" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Đặc tính:", -1))
const _hoisted_24 = { class: "fw-bold vat-tu-multiline-text" }
const _hoisted_25 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Thời gian tạo:", -1))
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Tạo Vật tư thu hồi", -1))
const _hoisted_30 = { class: "col-12 col-md-6" }
const _hoisted_31 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Tên vật tư:", -1))
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Đơn vị tính:", -1))
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Mức dự trữ tối đa:", -1))
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "mb-3 d-flex align-items-start" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Ghi chú:", -1))
const _hoisted_42 = { class: "fw-bold vat-tu-multiline-text" }
const _hoisted_43 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Thời gian cập nhật:", -1))
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Cty quản lý", -1))
const _hoisted_48 = {
  key: 0,
  class: "mb-3 d-flex align-items-center"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted me-2 w-1/3" }, "Nhóm vật tư", -1))
const _hoisted_50 = {
  class: "inline-flex rounded-none",
  role: "group"
}

import { swalErrNotification } from "@/core/helpers/utils";
import { IVatTuResponseBase } from "@/core/interfaces/ApiResponses";
import { VatTuService } from "@/core/services/VatTu.service";
import { PropType, computed, ref, watch } from "vue";
import { formatQuantity } from "@/core/helpers/number-format";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { useRouter } from "vue-router";
import { useLoading } from "@/core/hooks/use-loading";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import { DetailModalShell } from "@/components/shared/modal";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import ConfirmationApproveDialog from "@/components/confirmation-approve-dialog/ConfirmationApproveDialog.vue";
import usePermission from "@/core/hooks/usePermission";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VatTuDetailModal',
  props: {
  showApproveButton: {
    type: Boolean,
    default: true,
  },
  showEditButton: {
    type: Boolean,
    default: false,
  },
  vatTuId: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
},
  emits: ["close", "refresh"],
  setup(__props, { emit: __emit }) {

const props = __props;

const { startLoading, endLoading } = useLoading();

const vatTuDetail = ref<IVatTuResponseBase | null>(null);

const { canDuyetVatTu } = usePermission();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const showApproveVatTuDialog = ref(false);

watch(
  () => props.vatTuId,
  async () => {
    if (!props.vatTuId) return;

    startLoading();

    try {
      const {
        data: { data },
      } = await VatTuService.fetchSupplyDetail(props.vatTuId);

      vatTuDetail.value = data;

      endLoading();
    } catch (e) {
      endLoading();

      await swalErrNotification(e, "Có lỗi xảy ra khi lấy thông tin vật tư");
    }
  }
);

const showEditButton = computed(() => {
  return (
    process.env.VUE_APP_IS_EDIT_VAT_TU_ENABLE === "true" && props.showEditButton
  );
});

const { push } = useRouter();

const emit = __emit;

const isModalDisplay = computed(() => !!vatTuDetail.value);

const { formatDisplayingDate } = useDateTime();

const hasZeroReserve = computed(() => {
  const d = vatTuDetail.value;
  if (!d) return false;
  const min = Number(d.muc_du_tru_toi_thieu);
  const max = Number(d.muc_du_tru_toi_da);
  return min === 0 || max === 0;
});

const closeModal = () => {
  vatTuDetail.value = null;

  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationApproveDialog, {
      "approve-type": "VAT_TU",
      "is-display": showApproveVatTuDialog.value,
      "vat-tu": vatTuDetail.value ?? undefined,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (showApproveVatTuDialog.value = false)),
      onOnConfirm: _cache[1] || (_cache[1] = 
      () => {
        vatTuDetail.value = null;
        _ctx.$emit('refresh');
        showApproveVatTuDialog.value = false;
      }
    )
    }, null, 8, ["is-display", "vat-tu"]),
    _createVNode(_unref(DetailModalShell), {
      "is-display": !!isModalDisplay.value,
      title: "Chi tiết vật tư",
      size: "xl",
      "lottie-topic": "danh-muc-vat-tu",
      onClose: closeModal
    }, _createSlots({
      footer: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_50, [
          (showEditButton.value)
            ? (_openBlock(), _createBlock(ButtonCustom, {
                key: 0,
                "data-autofocus": "",
                classes: `rounded-none m-0`,
                "button-type": _unref(ButtonsType).EDIT,
                "color-type": _unref(ButtonTypeColors).SUCCESS,
                "delay-time": 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (
            _unref(push)({
              name: 'cap-nhat-vat-tu',
              params: {
                id: vatTuDetail.value?.id,
              },
            })
          ))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Chỉnh sửa")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"]))
            : _createCommentVNode("", true),
          (
            vatTuDetail.value?.is_valid === 0 && __props.showApproveButton && _unref(canDuyetVatTu)
          )
            ? (_openBlock(), _createBlock(ButtonCustom, {
                key: 1,
                "data-autofocus": "",
                classes: `rounded-none m-0`,
                "button-type": _unref(ButtonsType).APPROVE,
                "color-type": _unref(ButtonTypeColors).WARNING,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showApproveVatTuDialog.value = true))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Duyệt")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"]))
            : _createCommentVNode("", true),
          _createVNode(ButtonCustom, {
            "data-autofocus": "",
            classes: `rounded-none m-0`,
            "button-type": _unref(ButtonsType).CANCEL,
            "color-type": _unref(ButtonTypeColors).DANGER,
            "delay-time": 0,
            onClick: closeModal
          }, {
            "button-label": _withCtx(() => [
              _createTextVNode("Đóng")
            ]),
            _: 1
          }, 8, ["button-type", "color-type"])
        ])), [
          [_directive_dialog_auto_focus, isModalDisplay.value]
        ])
      ]),
      default: _withCtx(() => [
        (!!vatTuDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString(vatTuDetail.value?.id), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(vatTuDetail.value?.ma_vat_tu), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatQuantity)(vatTuDetail.value?.muc_du_tru_toi_thieu ?? 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(vatTuDetail.value?.dac_tinh || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(formatDisplayingDate)(new Date(vatTuDetail.value?.created_at))), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_el_checkbox, {
                    id: "is-thu-hoi",
                    "model-value": vatTuDetail.value?.thu_hoi,
                    disabled: "",
                    size: "large"
                  }, null, 8, ["model-value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("span", _hoisted_33, _toDisplayString(vatTuDetail.value?.ten_vat_tu), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, _toDisplayString(vatTuDetail.value?.don_vi_tinh ?? "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(formatQuantity)(vatTuDetail.value?.muc_du_tru_toi_da ?? 0)), 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("span", _hoisted_42, _toDisplayString(vatTuDetail.value?.note || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(formatDisplayingDate)(new Date(vatTuDetail.value?.updated_at))), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode(_component_el_checkbox, {
                    id: "is-cong-ty-duyet",
                    "model-value": vatTuDetail.value?.cong_ty_duyet,
                    disabled: "",
                    size: "large"
                  }, null, 8, ["model-value"])
                ]),
                (vatTuDetail.value.danh_muc_vat_tu?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(BaseLink, {
                        to: {
                name: 'chi-tiet-danh-muc-vat-tu',
                params: { id: vatTuDetail.value.danh_muc_vat_tu[0].id },
              }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(vatTuDetail.value.danh_muc_vat_tu[0].ten_danh_muc), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (!!vatTuDetail.value)
        ? {
            name: "alert",
            fn: _withCtx(() => [
              (hasZeroReserve.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
                : _createCommentVNode("", true),
              (vatTuDetail.value?.is_valid === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["is-display"])
  ], 64))
}
}

})